import { combine, createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { moviesFavoritesEntityModel } from '~/entities/movies/favorites'
import { model as sessionModel } from '~/entities/session'
import { nay } from '~/shared/helpers'
import { libraryGridFavoritesMoviesWidget } from '~/widgets/library/grid/favorites/movies'
import { $libraryFavoritesMoviesTranslations } from './translations'

export const initLibraryFavoritesMoviesPage = createEvent()
export const leftLibraryFavoritesMoviesPage = createEvent()

sample({
  clock: initLibraryFavoritesMoviesPage,
  target: libraryGridFavoritesMoviesWidget.loadGridFavoritesMovies,
})

export const $isLibraryFavoritesMoviesEmptyPage = combine(
  moviesFavoritesEntityModel.$onlyFavoritesVodsGrid,
  (moviesFavoritesEntityModel) =>
    moviesFavoritesEntityModel && !moviesFavoritesEntityModel.content.length
)

sample({
  source: leftLibraryFavoritesMoviesPage,
  target: moviesFavoritesEntityModel.resetOnlyFavoritesVodsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: moviesFavoritesEntityModel.resetOnlyFavoritesVodsGrid,
})

register(
  $libraryFavoritesMoviesTranslations,
  '$libraryFavoritesMoviesTranslations'
)
register(
  moviesFavoritesEntityModel.$onlyFavoritesVodsGridFormatted,
  '$library/favorites/movies/onlyFavoritesVodsGridFormatted'
)
register(
  $isLibraryFavoritesMoviesEmptyPage,
  '$isLibraryFavoritesMoviesEmptyPage'
)
register(
  libraryGridFavoritesMoviesWidget.loadMoreGridFavoritesMovies,
  'loadMoreGridFavoritesMovies'
)
